import { Box } from '@mui/material';
import * as React from 'react';
import BookChapterTable from './bookChapterTable';

export default function BookChapterLayout() {
  return (
    <Box sx={{ mt: 2 }}>
      <BookChapterTable />
    </Box>
  );
}
